<div class="card pos-info mt-4">
  <div class="title-wrap">
    <div class="img-wrapper">
      <img src="../../../../assets/img/pos.svg" class="fill-color" alt="pos">
    </div>
    <h4>Deployment Information</h4>
  </div>
  <div class="wrapper-content" *ngIf="deploymentInfo?.deploymentRequestsStatus == 'NewDeployed' || deploymentInfo?.deploymentRequestsStatus == 'ReDeployed'">
    <div class="title">
      <h5>Deployment Date: </h5>
      <h5>Terminal Type: </h5>
      <h5>Serial No: </h5>
      <h5>Property:</h5>
      <h5>Connectivity:</h5>
      <h5>Application Version:</h5>
      <h5>Deployment By: </h5>
      <h5>Deployed At:</h5>
      <h5>Received By ContactNo:</h5>
    </div>
    <div class="info">
      <h5>{{deploymentInfo?.deployedDate}}</h5>
      <h5>{{deploymentInfo?.terminalType}}</h5>
      <h5>{{deploymentInfo?.serialNo}}</h5>
      <h5>{{deploymentInfo?.property}}</h5>
      <h5>{{deploymentInfo?.connectivity}}</h5>
      <h5>{{deploymentInfo?.applicationVersion}}</h5>
      <h5>{{deploymentInfo?.deploymentBy}}</h5>
      <h5>{{deploymentInfo?.deployedAt}}</h5>
      <h5>{{deploymentInfo?.receivedContactNo}}</h5>
    </div>
  </div>
</div>
  <div class="col-lg-12" >
    <div class="wrapper-empty-content">
      <div class="title-wrap justify-content-center">
        <img src="../../../../../assets/img/empty-box.png" class="fill-color" alt="deployment-informaton" style="width: 100px;">
      </div>
      <div class="title-wrap justify-content-center" *ngIf="deploymentInfo?.deploymentRequestsStatus != 'NewDeployed' && deploymentInfo?.deploymentRequestsStatus != 'ReDeployed'">
        <h4>Terminal status is {{deploymentInfo?.deploymentRequestsStatus}}.</h4>
      </div>
    </div>
  </div>


